import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import 'react-focus-on';
import '@reach/auto-id';
import '@reach/portal';
import '../Transition/index.js';
import '../Box/index.js';
import '../CloseButton/index.js';
import '../Modal/ModalContent.js';
import { ModalFooter } from '../Modal/ModalFooter.js';

/**
 * The DrawerFooter is a subcomponent of Drawer to provide content and action buttons
 * for the Drawer
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/drawer)
 * - [Props](https://blockparty.endpoint.com/components/drawer#drawerfooter-props)
 * <br />
 *
 */
const DrawerFooter = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(ModalFooter, _extends({
    ref: forwardedRef,
    backgroundColor: "white",
    bottom: "0",
    id: "drawer-footer",
    position: "fixed",
    width: "100%"
  }, rest), children);
});

export { DrawerFooter };
